import type {
  SocialProfileMatchedFactResponseDto,
  SocialProfileSuggestionWithContactResponseDto,
} from "@shared/generated/crm";

type SuggestionPlatform =
  SocialProfileSuggestionWithContactResponseDto["platform"];

export const PLATFORM_LABELS: Record<SuggestionPlatform, string> = {
  instagram: "Instagram",
  linkedin: "LinkedIn",
  facebook: "Facebook",
};

export const MATCHED_FACT_LABELS: Record<
  SocialProfileMatchedFactResponseDto["field"],
  string
> = {
  name: "Name",
  company: "Company",
  title: "Title",
  location: "Location",
};

export type ConfidenceLevel = "low" | "medium" | "high" | "veryHigh";

export const CONFIDENCE_LABELS: Record<ConfidenceLevel, string> = {
  low: "Low confidence",
  medium: "Medium confidence",
  high: "High confidence",
  veryHigh: "Very high confidence",
};

export const getConfidenceLevel = (score: number): ConfidenceLevel => {
  if (score < 0.25) return "low";
  if (score < 0.5) return "medium";
  if (score < 0.75) return "high";
  return "veryHigh";
};

export const toSafeExternalUrl = (url: string): string | null => {
  try {
    const parsed = new URL(url);
    return parsed.protocol === "https:" || parsed.protocol === "http:"
      ? parsed.href
      : null;
  } catch {
    return null;
  }
};
